import {
  VEHICLES_LIST,
  ADD_VEHICLE,
  UPDATE_VEHICLE,
  VEHICLE_DELETE,
  LOADING,
  ADD0N_VEHICLES_LIST,
  ADDON_VEHICLE_DELETE,
  NOT_FOUND,
} from "../action/type";
import { APIURL } from "./config";
import { toast } from "react-toastify";
import axios from "axios";

export const ManageVehcleList = () => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/vehicle`, config);
    dispatch({
      type: VEHICLES_LIST,
      payload: res.data,
    });
    if (res.data?.data?.vehicle?.length === 0) {
      dispatch({
        type: NOT_FOUND,
        payload: "",
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
export const addVehicle = (val) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  var body = JSON.stringify({
    name: val.name,
    color: val.color,
    image: val.image,
    isBooked: val.isBooked,
    price: val.price,
    registration_no: val.registration_no,
    status: val.status,
    vehicle_model: val.vehicle_model,
    year: val.year,
    perWeekPrice: val.perWeekPrice,
  });
  try {
    const res = await axios.post(`${APIURL}/api/v1/vehicle`, body, config);
    dispatch({ type: ADD_VEHICLE, payload: res.data });
    toast.success("Vehicle Created Successfully!");
    setTimeout(() => {
      return (window.location.href = "/all-rentals");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const vehicleAddon = (val, callBack) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  var body = JSON.stringify({
    addName: val.addName,
    price: val.price,
    isChecked: val.isChecked,
  });
  try {
    const res = await axios.post(`${APIURL}/api/v1/price`, body, config);
    // toast.success("Add on item Added Successfully!");
    // setTimeout(() => {
    //   return (window.location.href = "/mange-rental-add-on");
    // }, 1000);
    if (res) {
      callBack("success");
    }
  } catch (error) {
    callBack("error");
    // toast.error(error?.response?.data?.message);
  }
};

export const vehicleUpdateAddon = (val, id, callBack) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  var body = JSON.stringify({
    addName: val.addName,
    price: val.price,
    isChecked: val.isChecked,
    // childPrice: val.childPrice,
    // mobilePrice: val.mobilePrice,
    // driverPrice: val.driverPrice,
    // totalSeat: val.totalSeat,
    // isChecked: val.isChecked,
  });
  try {
    const res = await axios.patch(`${APIURL}/api/v1/price/${id}`, body, config);
    if (res) {
      callBack("success");
    }
  } catch (error) {
    callBack("error");
    // toast.error(error?.response?.data?.message);
  }
};

export const updateVehicle = (val, id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  var body = JSON.stringify({
    name: val.name,
    color: val.color,
    image: val.image,
    isBooked: val.isBooked,
    price: val.price,
    registration_no: val.registration_no,
    status: val.status,
    vehicle_model: val.vehicle_model,
    year: val.year,
    perWeekPrice: val.perWeekPrice,
  });

  try {
    const res = await axios.patch(
      `${APIURL}/api/v1/vehicle/${id}`,
      body,
      config
    );
    dispatch({ type: UPDATE_VEHICLE, payload: res.data });
    toast.success("Vehicle Updated Successfully!");
    setTimeout(() => {
      return (window.location.href = "/all-rentals");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const deleteVehicle = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete vehicle?") === true) {
      const res = await axios.delete(`${APIURL}/api/v1/vehicle/${id}`, config);
      dispatch({
        type: VEHICLE_DELETE,
        payload: res.data,
      });
      toast.success("Vehicle Deleted Successfully!");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const deleteMultiVehicle = (ids) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const label = ids?.length > 1 ? "Vehicles" : "Vehicle";
  try {
    if (window.confirm(`Do you want to delete the selected ${label.toLowerCase()}?`) === true) {
      const res = await axios.delete(
        `${APIURL}/api/v1/vehicle/delete/${ids}`,
        config
      );
      dispatch({
        type: VEHICLE_DELETE,
        payload: res.data,
      });
      toast.success(`${label} Deleted Successfully!`);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const vehicleAddonList = (val) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/price`, config);
    dispatch({
      type: ADD0N_VEHICLES_LIST,
      payload: res.data,
    });
    if (res.data?.data?.vehicle?.length === 0) {
      dispatch({
        type: NOT_FOUND,
        payload: "",
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const vehicleAddonDelete = (id, funvehicleAddon) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete the selected add on?")) {
      const res = await axios.delete(`${APIURL}/api/v1/price/${id}`, config);
      dispatch({
        type: ADDON_VEHICLE_DELETE,
        payload: res.data,
      });
      funvehicleAddon();
      toast.success("Add on item Deleted Successfully!");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
